import React from 'react';
import PaymentsSubscriptions from '../../PaymentsSubscriptions';
import { SUBSCRIPTION_HAS_COUPON_REDEEMED_STATUSES } from '@/dashboard/services/status/hasCouponRedeemedStatuses';
import { COUPON_FILTER_OPTIONS } from '@/dashboard/lib/subscriptionsConstants';

const DiscountsCouponsSubscriptionsRedemptions = ({ coupon }) => {
  return (
    <PaymentsSubscriptions
      title="Subscription redemptions"
      baseFilters={{
        coupon: coupon._id,
        status: SUBSCRIPTION_HAS_COUPON_REDEEMED_STATUSES,
      }}
      exportLabel="coupon redemptions"
      hidePageFilter
      embedded
      filterOptions={COUPON_FILTER_OPTIONS}
    />
  );
};

export default DiscountsCouponsSubscriptionsRedemptions;
